import { formatShareValue, getIssuedShareCount } from './common';
import { TCapTableDataItem } from './types';

const ShareCapitalSummary = ({
  authorizedShares,
  pricePerShare,
  capTableData,
  currency,
}: {
  authorizedShares?: number | null;
  pricePerShare?: number | null;
  capTableData: TCapTableDataItem[];
  currency: string;
}) => {
  const price = pricePerShare || 0;
  const authorized = authorizedShares || 0;
  const issued = getIssuedShareCount(capTableData);

  const rows = [
    { label: 'Authorized shares', shares: authorized },
    { label: 'Issued shares', shares: issued },
  ];

  return (
    <div className="flex flex-col rounded-2xl border divide-y">
      {rows.map(({ label, shares }) => (
        <div
          key={label}
          className="grid grid-cols-3 gap-4 px-4 py-3 text-sm items-center"
        >
          <span className="text-text-secondary">{label}</span>
          <span className="text-text-primary">
            {shares.toLocaleString('en-US')} shares
          </span>
          <span className="text-text-primary text-right">
            {formatShareValue(shares * price, currency)}
          </span>
        </div>
      ))}
    </div>
  );
};

export default ShareCapitalSummary;
